export interface IContextObj {
  ACTION: string;
  DATA: string;
}

export interface ITrackActionObj {
  pageName: string;
  linkname: string;
  data: string;
}

export const PAGES = {
  TERMS_AND_CONDITIONS: 'Terms & Conditions',
  HOME: 'Home',
  TABLE_OF_CONTENTS: 'Table of Contents',
  PRODUCT_CONTENT: 'Product Content',
  REFERENCES: 'References'
};

export const ACTIONS_CLICK = {
  ACCEPT_TERMS_AND_CONDITIONS: 'Accept Terms & Conditions',
  DECLINE_TERMS_AND_CONDITIONS: 'Disagree Terms & Conditions',
};

export const ACTION = {
  LINK_TYPE: 'internal'
};
